module.exports = __webpack_public_path__ + "img/logo.759f3800.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.png
// module id = dLd/
// module chunks = 1